import NAME from "./constants";

export const GET_ASSISTANCE_ROWS = NAME + "/GET_ASSISTANCE_ROWS";
export const GET_ASSISTANCE_ROWS_FULFILLED = NAME + "/GET_ASSISTANCE_ROWS_FULFILLED";
export const GET_ASSISTANCE_ROWS_REJECTED = NAME + "/GET_ASSISTANCE_ROWS_REJECTED";

export const GET_MAP_DATA = NAME + "/GET_MAP_DATA";
export const GET_MAP_DATA_FULFILLED = NAME + "/GET_MAP_DATA_FULFILLED";
export const GET_MAP_DATA_REJECTED = NAME + "/GET_MAP_DATA_REJECTED";

export const CREATE_ASSISTANCE_MARK = NAME + "/CREATE_ASSISTANCE_MARK";
export const CREATE_ASSISTANCE_MARK_FULFILLED = NAME + "/CREATE_ASSISTANCE_MARK_FULFILLED";
export const CREATE_ASSISTANCE_MARK_REJECTED = NAME + "/CREATE_ASSISTANCE_MARK_REJECTED";

export const UPDATE_ASSISTANCE_MARK = NAME + "/UPDATE_ASSISTANCE_MARK";
export const UPDATE_ASSISTANCE_MARK_FULFILLED = NAME + "/UPDATE_ASSISTANCE_MARK_FULFILLED";
export const UPDATE_ASSISTANCE_MARK_REJECTED = NAME + "/UPDATE_ASSISTANCE_MARK_REJECTED";

export const DELETE_ASSISTANCE_MARK = NAME + "/DELETE_ASSISTANCE_MARK";
export const DELETE_ASSISTANCE_MARK_FULFILLED = NAME + "/DELETE_ASSISTANCE_MARK_FULFILLED";
export const DELETE_ASSISTANCE_MARK_REJECTED = NAME + "/DELETE_ASSISTANCE_MARK_REJECTED";

export const GET_CHANGE_SCHEDULE = NAME + "/GET_CHANGE_SCHEDULE";
export const GET_CHANGE_SCHEDULE_FULFILLED = NAME + "/GET_CHANGE_SCHEDULE_FULFILLED";
export const GET_CHANGE_SCHEDULE_REJECTED = NAME + "/GET_CHANGE_SCHEDULE_REJECTED";

export const UPDATE_SCHEDULE = NAME + "/UPDATE_SCHEDULE";
export const UPDATE_SCHEDULE_FULFILLED = NAME + "/UPDATE_SCHEDULE_FULFILLED";
export const UPDATE_SCHEDULE_REJECTED = NAME + "/UPDATE_SCHEDULE_REJECTED";